import React from 'react';

import {
    required,
    ReferenceInput,
    SelectInput,
    Create,
    SimpleForm,
    NumberInput,
    BooleanInput,
    FormDataConsumer,
} from 'react-admin';

import * as apiClient from "../../../common/apiClient";
import PopupCreateToolbar from "../../../common/PopupCreateToolbar";

const NetPremiumCreate = props => {

    const handleSubmit = (formdata) => {

        console.log("Net Premium Form Data:", formdata);

        let user = localStorage.getItem("userId");

        if (user) {
            user = parseInt(user);
        }

        const data = {
            rfqRegisterId: parseInt(props.rfqRegisterId),

            // SQL: int
            finYearId: formdata.finYearId
                ? parseInt(formdata.finYearId)
                : null,

            // SQL: numeric(18,2)
            netPremium: formdata.netPremium
                ? parseFloat(formdata.netPremium)
                : null,

            // SQL: bit
            isClaim: formdata.isClaim !== undefined
                ? formdata.isClaim
                : false,

            // SQL: numeric(18,2)
        claimAmount: formdata.isClaim
            ? Number(formdata.claimAmount || 0)
            : 0,
                // SQL: int
            createdBy: user,

            // IsActive has SQL DEFAULT = 1
            isActive: formdata.isActive !== undefined
                ? formdata.isActive
                : true,
        };

        console.log("Saving Net Premium:", data);

        apiClient
            .addEntiyRecord("rfq-register-net-premiums", data)
            .then(res => {

                console.log("Net Premium Saved:", res);

                if (props.onClose) {
                    props.onClose();
                }

            })
            .catch(err => {
                console.log("Error saving Net Premium:", err);
            });
    };

    return (
        <Create {...props}>

            <SimpleForm
                onSubmit={handleSubmit}
                toolbar={
                    <PopupCreateToolbar
                        label="Save"
                        onSave={handleSubmit}
                        onClose={props.onClose}
                        onCancel={props.onCancel}
                    />
                }
                variant="outlined"
            >

                {/* Financial Year */}
                <ReferenceInput
                    label="Financial Year"
                    source="finYearId"
                    reference="lookups"
                    filter={{ type: 'RFQFINY' }}
                    perPage={5000}
                    sort={{ field: 'name', order: 'ASC' }}
                    validate={[required()]}
                    fullWidth
                >
                    <SelectInput optionText="name" />
                </ReferenceInput>


                {/* Net Premium */}
                <NumberInput
                    source="netPremium"
                    label="Net Premium"
                    validate={[required()]}
                    fullWidth
                    step={0.01}
                />


                {/* Is Claim */}
                <BooleanInput
                    source="isClaim"
                    label="Is Claim"
                    defaultValue={false}
                />


                {/* Claim Amount */}
                <FormDataConsumer>
                    {({ formData }) => (
                        <NumberInput
                            source="claimAmount"
                            label="Claim Amount"
                            step={0.01}
                            fullWidth
                            disabled={!formData.isClaim}
                            defaultValue={0}
                            parse={v => Number(v || 0)}
                            format={v => v ?? 0}
                        />
                    )}
                </FormDataConsumer>

                {/* Is Active */}
                <BooleanInput
                    source="isActive"
                    label="Is Active"
                    defaultValue={true}
                />

            </SimpleForm>

        </Create>
    );
};

export default NetPremiumCreate;
